angular.module('unica_workshop.workshop_controllers')

.controller('WorkshopRegisteredController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	WorkshopListService, WorkshopDeleteService, CheckService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getWorkshop( $stateParams.id );

	$scope.registered = [];
	$scope.limit  = 10;
	$scope.offset = 0;

	$scope.loadWorkshopRegistered = function() {
		$scope.showLoader();
		$scope.canLoad = false;

		WorkshopListService
			.registered( $stateParams.id, $scope.limit, $scope.offset )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					data = $rootScope.parseWorkshopSession( data );

					$scope.registered = $scope.registered.concat( data );
					if ( data.length === 0 ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadWorkshopRegistered();

	$scope.checkInWorkshop = function(invitationId, hash) {
		$scope.showLoader();
		CheckService
			.checkInWorkshop( hash )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					angular.forEach($scope.registered, function(invitation, key) {
						if ( invitation.id == invitationId ) {
							if ( $scope.registered[key].checked_in ){
								$scope.registered[key].checked_out_date = true;
							} else {
								$scope.registered[key].checked_in = true;
							}
						}
					});
					$scope.showSuccessMsg('Check-in effettuato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	}

	$scope.checkOutWorkshop = function(invitationId, hash) {
		$scope.showLoader();
		CheckService
			.checkOutWorkshop( hash )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					angular.forEach($scope.registered, function(invitation, key) {
						if ( invitation.id == invitationId ) {
							if ( $scope.registered[key].checked_in ){
								$scope.registered[key].checked_out_date = true;
							} else {
								$scope.registered[key].checked_in = true;
							}
						}
					});
					$scope.showSuccessMsg('Check-out effettuato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	}


	$scope.checkOutInvitation = function(invitationId, hash) {
		$scope.showLoader();
		CheckService
			.checkOutInvitation( hash )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					angular.forEach($scope.registered, function(invitation, key) {
						if ( invitation.id == invitationId ) {
							$scope.registered[key].checked_in = !$scope.registered[key].checked_in;
							$scope.registered[key].checked_out_date = undefined;
						}
					});
					$scope.showSuccessMsg('Check annullato con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	}

	$scope.prepareExportUrl = function() {
		$scope.showLoader();
		WorkshopListService
			.export( $stateParams.id ) //workshopId
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportWorkshop = true;
					$scope.exportWorkshopUrl      = url;
				}
			});
	};


	$scope.deleteInvitation = function( invitationId ) {

		$confirm({
			title: 'Sei sicuro di voler eliminare la Prenotazione al Workshop?',
			text: 'Confermi la cancellazione della la Prenotazione al Workshop?'
		}).then(function() {

			$scope.showLoader();
			WorkshopDeleteService
				.deleteWorkshopSessionInvitation( invitationId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.registered, function(invitation, key) {
							if ( invitation.id === invitationId ) {
								$scope.registered.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Prenotazione al Workshop eliminata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

});